module.exports = __webpack_public_path__ + "img/vafler_zoom.7128126f.jpg";